import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { useCreateConsultationMutation } from '@/core/services/consultation'
import { ConsultationStatus, ConsultationType, CreateConsultationDto } from '@/core/models/consultation.model'

export function useStartLocalConsultation() {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const [createConsultation, { isLoading: isCreatingConsultation }] = useCreateConsultationMutation()

  const startLocalConsultation = useCallback(
    async (patientId: string) => {
      if (!patientId) return

      try {
        const consultationDto: CreateConsultationDto = {
          patient: patientId,
          type: ConsultationType.Local,
          status: ConsultationStatus.Active,
          startDate: new Date().toISOString(),
        }

        const consultation = await createConsultation(consultationDto).unwrap()
        
        enqueueSnackbar(t('notification.localConsultation.create.success'), { variant: 'success' })
        navigate(`/consultations/${consultation._id}/local`)
      } catch (error) {
        console.error('Error starting local consultation:', error)
        enqueueSnackbar(t('notification.consultation.create.error'), { variant: 'error' })
      }
    },
    [createConsultation, navigate, enqueueSnackbar, t]
  )

  return {
    startLocalConsultation,
    isCreatingConsultation,
  }
}
